const stats = [
  { value: '500万+', label: '注册用户' },
  { value: '100万+', label: '日均访问' },
  { value: '2000+', label: '优质文章' },
  { value: '6', label: '内容分类' },
];

export default function StatsSection() {
  return (
    <section className="py-14 md:py-20 bg-accent-500">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8">
          {stats.map((stat, index) => (
            <div key={index} className="text-center">
              <p className="text-3xl md:text-4xl font-bold text-background-50 mb-1">
                {stat.value}
              </p>
              <p className="text-sm text-background-50/80">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}